// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    BmsGetNextBusinessDaysRequestModel,
    BmsGetNextBusinessDaysResponseModel,
    BmsScheduleAppointmentRequestModel,
    BmsScheduleAppointmentResponseModel,
    GatewayError,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeBmsApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param bmsGetNextBusinessDaysRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async appointmentGetNextBusinessDay (bmsGetNextBusinessDaysRequestModel: BmsGetNextBusinessDaysRequestModel, xProgramId?: string): Promise<AxiosResponse<BmsGetNextBusinessDaysResponseModel>> {
        const _url_ = '/edge/bms/appointment/v1/appointment/getNextBusinessDay';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'bmsGetNextBusinessDaysRequestModel' is not null or undefined
        if (bmsGetNextBusinessDaysRequestModel === null || bmsGetNextBusinessDaysRequestModel === undefined) {
            throw new Error('Required parameter bmsGetNextBusinessDaysRequestModel was null or undefined when calling appointmentGetNextBusinessDay.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(bmsGetNextBusinessDaysRequestModel, "BmsGetNextBusinessDaysRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<BmsGetNextBusinessDaysResponseModel>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "BmsGetNextBusinessDaysResponseModel");
        }
        return response;
    }
    /**
     * 
     * @param bmsScheduleAppointmentRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async appointmentScheduleAppointment (bmsScheduleAppointmentRequestModel: BmsScheduleAppointmentRequestModel, xProgramId?: string): Promise<AxiosResponse<BmsScheduleAppointmentResponseModel>> {
        const _url_ = '/edge/bms/appointment/v1/appointment/scheduleAppointment';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'bmsScheduleAppointmentRequestModel' is not null or undefined
        if (bmsScheduleAppointmentRequestModel === null || bmsScheduleAppointmentRequestModel === undefined) {
            throw new Error('Required parameter bmsScheduleAppointmentRequestModel was null or undefined when calling appointmentScheduleAppointment.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(bmsScheduleAppointmentRequestModel, "BmsScheduleAppointmentRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<BmsScheduleAppointmentResponseModel>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "BmsScheduleAppointmentResponseModel");
        }
        return response;
    }
}
